import request from '@/utils/request'

export function create(data) {

  return request({
    url: '/checkItem/create',
    method: 'POST',
    data})
}

   

export function createBatch(data) {

  return request({
    url: '/checkItem/create/batch',
    method: 'POST',
    data})
}

   

export function deleteById(data) {

  return request({
    url: '/checkItem/deleteById',
    method: 'POST',
    data})
}

   

export function deleteByIds(data) {

  return request({
    url: '/checkItem/deleteByIds',
    method: 'POST',
    data})
}

   

export function getById(params) {

  return request({
    url: '/checkItem/getById',
    method: 'GET',
    params})
}

   

export function getByIds(params) {

  return request({
    url: '/checkItem/getByIds',
    method: 'GET',
    params})
}

   

export function list(params) {

  return request({
    url: '/checkItem/list',
    method: 'GET',
    params})
}

   

export function update(data) {

  return request({
    url: '/checkItem/update',
    method: 'POST',
    data})
}

   

export function updateBatch(data) {

  return request({
    url: '/checkItem/update/batch',
    method: 'POST',
    data})
}

   